

import { form18DataInfoType } from '@/types/Information/Form18';
import { partiesDataJsonDataType, serviceInformationJsonDataType } from '@/types/Information/json';
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form18";
const form18State = namespace("Form18");

@Component
export default class Form18StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;

    @informationState.State
    public fileNumber: string;

    @form18State.State
    public form18Info: form18DataInfoType;

    @form18State.Action
    public UpdateForm18Info!: (newForm18Info: form18DataInfoType) => void  
    
    @form18State.State
    public currentNoticeOfRepChangeAddressId: string;

    @form18State.Action
    public UpdateCurrentNoticeOfRepChangeAddressId!: (newCurrentNoticeOfRepChangeAddressId: string) => void
    
    dataReady = false;
    applicantNames: string[] = [];
    respondentNames: string[] = [];
    partyNames: string[] = [];
    
    changeRepresentationOptions = [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
    ];

    areYouLawyerOptions = [
        { text: 'Yes', value: true },
        { text: 'No', value: false }
    ];

    representationOptions = [ 'Self-represented', 'Lawyer' ];
    lawyerRepresentationOptions = [ 'Lawyer' ];

    provinces = [
        {text:'British Columbia', value:'BC'}, 
        {text:'Ontario', value:'ON'}, 
        {text:'Quebec', value:'QC'}, 
        {text:'Alberta', value:'AB'}, 
        {text:'Saskatchewan', value:'SK'}, 
        {text:'Manitoba', value:'MB'},
        {text:'Newfoundland and Labrador', value:'NL'},
        {text:'Newfoundland', value:'NL'},
        {text:'Labrador', value:'NL'},
        {text:'Prince Edward Island', value:'PE'},
        {text:'Nova Scotia', value:'NS'},
        {text:'New Brunswick', value:'NB'},
        {text:'Yukon', value:'YT'},
        {text:'Northwest Territories', value:'NT'},
        {text:'Nunavut', value:'NU'}
    ]

    state = {
        firstAppellant: null,
        firstRespondent: null,
        changeRepresentation: null,
        currentRepresentation: null,
        currentLawyerName: null,
        newRepresentation: null,  
        newLawyerName: null, 
        areYouLawyer: null,
        nameOfLawyer: null,
        phone:null,
        email:null,
        addressLine1:null,
        city:null,
        postalCode:null,
        counselFirstName:null,
        counselLastName:null,
        firmName:null,
        firmPhone:null,
        filingParties:null,            
        authorizedName:null,
        selfRepresented:null,
        province:null,
        nonBcAddress: null
    }

    respondentName = ""; 
    updated=0;  
    showNoneBcAlert=false

    mounted() {
        this.dataReady = false;
        this.extractInfo();
        this.dataReady = true;
              
    }

    public extractInfo(){     

        if(this.currentNoticeOfRepChangeAddressId){
            this.getForm18Data();
           
        } else {  
            const form18Data = {} as form18DataInfoType;                  

            form18Data.appellants = this.partiesJson.appellants
            form18Data.respondents = this.partiesJson.respondents;
            form18Data.formSevenNumber = this.fileNumber;
            form18Data.serviceInformation = {} as serviceInformationJsonDataType;
            form18Data.serviceInformation.province = "BC";
            form18Data.serviceInformation.country = "Canada";
            form18Data.filingParties = [];           
            form18Data.version = this.$store.state.Application.version;
            form18Data.useServiceEmail = false
            form18Data.sendNotifications = false           
            this.UpdateForm18Info(form18Data);            
            this.saveForm(true); 
        } 
    }

    public extractPartiesData(){

        this.applicantNames = [];
        this.respondentNames = [];

        for (const respondent of this.form18Info.respondents){
            this.respondentNames.push(respondent.name);
            this.partyNames.push(respondent.name)
        }

        for (const applicant of this.form18Info.appellants){
            this.applicantNames.push(applicant.name); 
            this.partyNames.push(applicant.name);          
        }
        this.dataReady = true;

    }

    public getForm18Data() {        
       
        this.$http.get('/form18/forms/'+this.currentNoticeOfRepChangeAddressId)
        .then((response) => {
            if(response?.data?.data){            
                            
                const form18Data = response.data.data                
                this.UpdateForm18Info(form18Data) 
                this.extractPartiesData();
                this.clearStates();                
            }
                
        },(err) => {
            console.log(err)        
        });      
    }

    public toggleRepresentation(){

        Vue.nextTick(()=>
        {
            if ((!this.form18Info.changeRepresentation && !this.form18Info.selfRepresented) || 
                (this.form18Info.changeRepresentation && this.form18Info.newRepresentation == 'Lawyer')){
                const contactInfo = this.form18Info.respondents.filter(resp => {
                    if (resp.name  == this.respondentName) {
                        return true;
                    }
                })[0];

                if(contactInfo){
                    this.form18Info.serviceInformation.country = "Canada";
                    this.form18Info.serviceInformation.selectedContactId = contactInfo.id;
                    this.form18Info.serviceInformation.name = contactInfo.name;
                    this.form18Info.serviceInformation.counselFirstName = contactInfo.solicitor?.counselFirstName;
                    this.form18Info.serviceInformation.counselLastName = contactInfo.solicitor?.counselLastName;
                    this.form18Info.serviceInformation.firmName = contactInfo.solicitor?.firmName;
                    this.form18Info.serviceInformation.firmPhone = contactInfo.solicitor?.firmPhone;
                    this.form18Info.serviceInformation.email = "";
                    this.form18Info.serviceInformation.addressLine1 = contactInfo.solicitor?.addressLine1;
                    this.form18Info.serviceInformation.addressLine2 = contactInfo.solicitor?.addressLine2;
                    this.form18Info.serviceInformation.city = contactInfo.solicitor?.city;
                    this.form18Info.serviceInformation.postalCode = contactInfo.solicitor?.postalCode;
                    this.updated++;
                }

            }
            this.recheckStates()
        })
    }

    public clearStates(){
        this.state = {
            firstAppellant: null,
            firstRespondent: null,
            changeRepresentation: null,
            currentRepresentation: null,
            currentLawyerName: null,
            newRepresentation: null,  
            newLawyerName: null, 
            areYouLawyer: null,
            nameOfLawyer: null,
            phone:null,
            email:null,
            addressLine1:null,
            city:null,
            postalCode:null,
            counselFirstName:null,
            counselLastName:null,
            firmName:null,
            firmPhone:null,
            filingParties:null,           
            authorizedName:null,
            selfRepresented: null,
            province: null,
            nonBcAddress: null
        }
        this.dataReady = true; 
    }

    public recheckStates(){
        
        this.state.nonBcAddress = this.form18Info.serviceInformation?.province && this.form18Info.serviceInformation?.province != 'BC' ? true : null
        
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates()
                return 
            }
        }
    }

    public checkStates(){         
        
        if(this.form18Info.currentRepresentation!='Lawyer' && this.form18Info.newRepresentation!='Lawyer')
            this.form18Info.newRepresentation=''

        this.state.firstAppellant = !this.form18Info.firstAppellant? false : null;
        this.state.firstRespondent = !this.form18Info.firstRespondent? false : null;

        this.state.changeRepresentation = (this.form18Info.changeRepresentation == null)? false : null;

        const changeRep = this.form18Info.changeRepresentation;

        this.state.currentRepresentation = (changeRep && !this.form18Info.currentRepresentation)? false : null;
        this.state.currentLawyerName = (changeRep && this.form18Info.currentRepresentation=='Lawyer' && !this.form18Info.currentLawyerName)? false : null;

        this.state.newRepresentation = (changeRep && !this.form18Info.newRepresentation)? false : null;
        this.state.newLawyerName = (changeRep && this.form18Info.newRepresentation=='Lawyer' && !this.form18Info.newLawyerName)? false : null;


        const selfRep = this.form18Info.selfRepresented || (changeRep && this.form18Info.newRepresentation!='Lawyer');

        const phone = this.form18Info.serviceInformation?.phone?.trim()
        this.state.phone = (selfRep && Vue.filter('verifyPhone')(phone)==false)? false : null;

        this.state.counselFirstName = !selfRep && !this.form18Info.serviceInformation?.counselFirstName? false : null;
        this.state.counselLastName =  !selfRep && !this.form18Info.serviceInformation?.counselLastName? false : null;
        this.state.firmName =  !selfRep && !this.form18Info.serviceInformation?.firmName?  false : null;
        
        const firmPhone = this.form18Info.serviceInformation?.firmPhone?.trim()
        this.state.firmPhone = (!selfRep && Vue.filter('verifyPhone')(firmPhone)==false)? false : null;
        
        const email = this.form18Info.serviceInformation?.email?.trim();
        this.state.email =(email && !Vue.filter('verifyEmail')(email) ||(!email && this.form18Info.useServiceEmail))? false : null;
        
        this.state.addressLine1 = !this.form18Info.serviceInformation?.addressLine1? false : null;
        this.state.city = !this.form18Info.serviceInformation?.city? false : null;

        this.state.province = !this.form18Info.serviceInformation?.province ? false : null
        this.state.nonBcAddress = this.form18Info.serviceInformation?.province && this.form18Info.serviceInformation?.province != 'BC' ? true : null  

        const postalCode = this.form18Info.serviceInformation?.postalCode?.trim()
        this.state.postalCode = !Vue.filter('verifyPostCode')(postalCode)? false : null;        
        this.state.filingParties = (this.form18Info.filingParties?.length > 0)? null: false; 
           
        this.state.authorizedName = !this.form18Info.authorizedName? false : null; 
        this.state.selfRepresented = this.form18Info.selfRepresented==null && !changeRep? false :null

        // console.log(this.state)
        
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }
        }
        return true            
    }


    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form18/forms';

        if (this.currentNoticeOfRepChangeAddressId){
            method = 'put';
            url = '/form18/forms/'+this.currentNoticeOfRepChangeAddressId;               

            if (!draft && !this.checkStates()){               
                return                
            } 
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form18Info,
                    type:'Form18',
                    description:'Notice of Change of Representation/Change of Address for Service'
                }
            }
            this.saveInfo(options, draft);

        } else {           

            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form18Info,
                    type:'Form18',
                    description:'Notice of Change of Representation/Change of Address for Service'
                }
            }
            this.saveInfo(options, draft);
        }        
       
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentNoticeOfRepChangeAddressId(response.data.file_id);
                        this.extractPartiesData();                        
                    }

                    this.clearStates();                    
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;
                
            })
    }   

    public navigateToPreviewPage() {          
        if (this.checkStates()){
            if(this.state.nonBcAddress)
               this.showNoneBcAlert=true
            else
                this.$router.push({name: "preview-form18"});
        }        
    }

    public confirmNavigateToPreviewPage(){
        this.showNoneBcAlert=false
        this.$router.push({name: "preview-form18"});
    }

    get getServiceInfoCondition(){
        return ((this.form18Info.selfRepresented && !this.form18Info.changeRepresentation) ||
                (this.form18Info.newRepresentation == 'Self-represented' && this.form18Info.changeRepresentation))
    }   
}
